import React, { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Form, Input, InputRef } from "antd"
import { faLink } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"

interface IWebhookUrlFormItemProps {
  label: string
  name: string
  placeholder: string
  onChangeValidator?: () => any
  onSubmitValidator?: () => any
}

export const WebhookUrlFormItem: React.FC<IWebhookUrlFormItemProps> = ({
  label,
  name,
  placeholder,
  onChangeValidator,
  onSubmitValidator,
}) => {
  const { t } = useTranslation()
  const inputRef = React.useRef<InputRef>(null)

  useEffect(() => {
    setTimeout(() => {
      inputRef.current && inputRef.current.focus()
    }, 200)
  }, [])

  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        {
          required: true,
          message: "This field is required",
          validateTrigger: "onChange",
        },
        {
          type: "url",
          message: t("common.rules.validUrl"),
          validateTrigger: "onChange",
        },
        onChangeValidator ? onChangeValidator : {},
        onSubmitValidator ? onSubmitValidator : {},
      ]}
      hasFeedback
      validateFirst={true}
    >
      <Input
        prefix={
          <FontAwesomeIcon className={`flex-shrink-0 h-4 text-gray-400 ml-1 mr-2`} icon={faLink} />
        }
        autoComplete="off"
        placeholder={placeholder}
        size="large"
        ref={inputRef}
      />
    </Form.Item>
  )
}
